import React, { Component } from 'react';

import { Grid, Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import Select from 'react-select';
import { ConsultSemestres, ConsultaMaterias, Guardar, verMateria, Delete, Editar } from '../../funciones/MateriasFunction';
import { toast } from 'react-toastify';

import CustomModal from "../../components/Modal/CustomModal";

let statusBtn = 0;
let idMateria = null;
class Materias extends Component {
    state = {
        textInfo: <React.Fragment>Para agregar una nueva materia indica primero el <strong>Nivel</strong> a tu izquierda</React.Fragment>,
        valorSemestre: { value: '', label: '- Selecciona un Nivel -' },
        semestres: [{ value: '', label: ' - Cargando Espere - ', num: '' }],

        valorPrelacion1: { value: '', label: '- Selecciona la Prelación 1 -' },
        valorPrelacion2: { value: '', label: '- Selecciona la Prelación 2 -' },

        prelaciones: [{ value: '', label: ' - Selecciona un Nivel - ' }],

        valorModalidad: { value: '', label: '- Selecciona una Modalidad -' },
        modalidades: [{ value: '', label: ' - Selecciona un Nivel - ' }],

        valorTipoMat: { value: '', label: '- Selecciona un Tipo -' },
        TiposMat: [{ value: '', label: ' - Selecciona un Nivel - ' }],

        materiasDisp: [{ id: "", codigo: "", nombre: "" }],
        preloader:{ icon: "", text: "" },
        preloaderAsig:{ icon: "", text: "" },
        cantErrores: "",

        codigo:  { text:"", status: "" },
        nombre:  { text:"", status: "" },
        horas:  { text:"", status: "" },
        uc:  { text:"", status: "" },
        chkIntensivo:  false,
        boton1: { Icon:"fa fa-save", Title:"Guardar", disabled: ""},
        boton2: { Icon:"fa fa-times", Title:"", disabled: ""},
        boton3: { Icon:"fa fa-edit", Title:"", disabled: ""},
        boton4: { Icon:"fa fa-trash", Title:"", disabled: ""},
        openDelMat: false,
    }

    constructor (props) {
        super (props);
        statusBtn = 0;
        ConsultSemestres ((resp) => {
            this.setState({semestres: resp})
        })
    }

    cambiaChkIntensivo = () => (e) => {
        this.setState ({
            chkIntensivo: !this.state.chkIntensivo,
            openDelMat: false
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]:{
                text:(event.target.value).toUpperCase(),
                status: "",
            },
            openDelMat: false
        });
    };

    openWDelMat = () => {
        this.setState ({ openDelMat: true })
    }

    valorSelectMateria = (valorSemestre) => {
        this.setState({
            valorSemestre,
            preloader:{
                icon: "fa fa-spinner fa-spin",
                text: "Cargando"
            },
            textInfo: <React.Fragment>Haz seleccionado <strong>{valorSemestre.label}</strong></React.Fragment>,
            openDelMat: false
        },() => {
            ConsultaMaterias(valorSemestre.value, valorSemestre.num, valorSemestre.carrera, (resp) => {
                console.log(resp)
                this.setState(resp)
            })
        });
    }

    valorPrelacion1 = (valorPrelacion1) => { this.setState({valorPrelacion1, openDelMat: false}) }
    valorPrelacion2 = (valorPrelacion2) => { this.setState({valorPrelacion2, openDelMat: false}) }
    valorModalidad = (valorModalidad) => { this.setState({valorModalidad, openDelMat: false}) }
    valorTipoMat = (valorTipoMat) => { this.setState({valorTipoMat, openDelMat: false}) }

    materiasDisp = () => {
        let { materiasDisp } = this.state;

        if (materiasDisp[0] === undefined) return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                No existen secciones disponibles para este Nivel
            </div> 
        )

        if (materiasDisp[0].id === "") return (
            <div style={{fontSize:12, paddingTop:15}} align="center">
                Primero selecciona un <strong>Nivel</strong> para mostrar las asignaturas disponibles
            </div> 
        )

        let contenidoMateria = () => {
            return(
                materiasDisp.map(option => (
                    <tr onClick = {this.editMateria (option.id)} key={option.id} style={{cursor: "pointer"}} title = {`Haz Click para editar ${option.nombre}`}>
                        <td width="30%" style={{fontSize: 10}}>{option.codigo}</td>
                        <td width="70%" style={{fontSize: 10}}>{option.nombre}</td>
                    </tr>
                ))
            )
        }
        return (
            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                <Table striped hover>
                    <tbody>
                        {contenidoMateria()}
                    </tbody>
                </Table>
            </div>
        );
    }

    editMateria = (id) => (e) => {
        statusBtn = 1;
        idMateria = id;
        this.setState ({
            openDelMat: false,
            preloaderAsig:{ icon: "fa fa-spinner fa-spin", text: "" },
            boton2: { Icon:"fa fa-times", Title:"", disabled: "disabled"},
            boton3: { Icon:"fa fa-edit", Title:"", disabled: "disabled"},
            boton4: { Icon:"fa fa-trash", Title:"", disabled: "disabled"},
        }, () => {
            verMateria (id, (resp) => {
                this.setState(resp)
            })
        })
    }

    materias = () => {
        let { valorSemestre, semestres, preloader } = this.state;
        
        return (
            <div className="custom-alert-info" style={{padding: 10}}>
                <Select
                    isSearchable ={true}
                    value={valorSemestre}
                    onChange={this.valorSelectMateria}
                    options={semestres}
                />
                <div align="center" style={{marginTop:5}}><i className={preloader.icon}></i>{preloader.text}</div>
                <div style={{ overflowY :"auto", height:"45vh",}}>{this.materiasDisp()}</div>
            </div>
        )
    }

    respuestaGuardar = (resp) => {
        
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];
        
        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let mateOk = (mensaje) => {
            let { valorSemestre } = this.state;
            if (valorSemestre.value !== "") ConsultaMaterias(valorSemestre.value, valorSemestre.num, valorSemestre.carrera, (resp) => { this.setState(resp) })

            this.setState({
                boton1:{
                    Icon:"fa fa-save",
                    Title:"Guardar",
                }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }
        
        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.cancelar()
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        mateOk(mensaje[0]);
    }

    respuestaEditar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];
        
        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let mateOk = (mensaje) => {
            let { valorSemestre } = this.state;
            if (valorSemestre.value !== "") ConsultaMaterias(valorSemestre.value, valorSemestre.num, valorSemestre.carrera, (resp) => { this.setState(resp) })

            this.setState({
                boton3:{ Icon:"fa fa-edit" }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) this.setState({ cantErrores:"" })
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        mateOk(mensaje[0]);
    }

    cancelar = () => {
        statusBtn = 0;

        this.setState ({
            cantErrores: "",
            codigo:  { text:"", status: "" },
            nombre:  { text:"", status: "" },
            horas:  { text:"", status: "" },
            uc:  { text:"", status: "" },
            chkIntensivo:  false,
            boton1: { Icon:"fa fa-save", Title:"Guardar" },
            boton2: { Icon:"fa fa-times", Title:"" },
            boton3: { Icon:"fa fa-edit", Title:"" },
            boton4: { Icon:"fa fa-trash", Title:"" },
            valorPrelacion1: { value: '', label: '- Selecciona la Prelación 1 -' },
            valorPrelacion2: { value: '', label: '- Selecciona la Prelación 2 -' },
            valorModalidad: { value: '', label: '- Selecciona una Modalidad -' },
            valorTipoMat: { value: '', label: '- Selecciona un Tipo -' },
            openDelMat: false,
        })
    }

    delMateria = () => {
        let { nombre, valorSemestre } = this.state;
        let contenidoModal = <div>
            ¿Desea realmente <strong>eliminar la asignatura <span className="text-info">{nombre.text}</span></strong> del Sistema?
            </div>
        return (
            <CustomModal
                isopen =  {this.state.openDelMat}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = "Si"
                boton2 = "No"
                funcion1 = { Delete(idMateria, () => {
                    if (valorSemestre.value !== "") ConsultaMaterias(valorSemestre.value, valorSemestre.num, valorSemestre.carrera, (resp) => { this.setState(resp) })
                    toast.info("La asignatura fue eliminada exisosamente",{autoClose: 4000});
                    this.cancelar()
                })}/>
        );
    }

    botones = () => {
        let { valorSemestre, codigo, nombre, horas, uc, valorModalidad, valorTipoMat, valorPrelacion1,
            valorPrelacion2, chkIntensivo, boton1, boton2, boton3, boton4 } = this.state;
        const campos = { valorSemestre, codigo, nombre, horas, uc, valorModalidad, valorTipoMat, valorPrelacion1,
            valorPrelacion2, chkIntensivo }

            switch (statusBtn) {
                case 0:
                    return (
                        <button className="btn btn-primary" disabled={boton1.disabled} style={{borderWidth: 1}} onClick={ (e) => {
                            this.setState({
                                boton1:{ Icon: "fa fa-spinner fa-spin", Title: "Cargando" }
                            }, () => {
                                Guardar (campos, (resp) => { this.respuestaGuardar(resp) })
                            })
                        }}><i className={boton1.Icon}></i> {boton1.Title}</button>
                    )
                case 1:
                    return (
                        <div className="btn-group" role="group">
                            <button className="btn btn-primary"  disabled={boton2.disabled} onClick ={this.cancelar} title="Cancelar" style={{borderWidth: 1}}><i className={boton2.Icon}></i></button>
                            <button className="btn btn-warning"  disabled={boton3.disabled}
                            onClick={ (e) => {
                                this.setState({
                                    boton3:{ Icon: "fa fa-spinner fa-spin" },
                                    openDelMat: false
                                }, () => {
                                    Editar (idMateria, campos, (resp) => { this.respuestaEditar(resp) })
                                })
                            }}
                            title="Editar esta Asignatura" style={{borderWidth: 1}}><i className={boton3.Icon}></i></button>
                            <button className="btn btn-danger" disabled={boton4.disabled} onClick={this.openWDelMat} title="Eliminar esta Asignatura" style={{borderWidth: 1}}><i className={boton4.Icon}></i></button>
                        </div>
                    )
                default:
                    return (<div></div>)
            }
    }

    registro = () => {
        let { valorPrelacion1, valorPrelacion2, prelaciones, valorModalidad, modalidades, valorTipoMat, TiposMat, textInfo, cantErrores,
            codigo, nombre, horas, uc, chkIntensivo, preloaderAsig } = this.state;

        let MainAyuda = (
            <Popover title="Registro de Materias" id="mat">
                <div align="justify">
                    Para Registrar las materias, es necesario que selecciones primero el <strong>Nivel</strong> a tu izquierda,
                    luego completa los campos para registrarla.<hr/>
                    También puedes hacer <strong>Click</strong> en alguna materia para editarla.<hr/>
                    <div align="center" style={{fontSize: 10, fontWeight:"bold", paddingTop: 5}} className="custom-alert-warning">
                        Si deseas una materia específica solo escribe su nombre o parte de él para que aparezca
                    </div>
                </div>
            </Popover>
        )

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        return (
            <React.Fragment>
                <div className="custom-alert-success">
                    <Row>
                        <Col md={9} style={{paddingTop: 8, paddingLeft: 25}}>
                        <span><i className={preloaderAsig.icon}></i>{preloaderAsig.text}</span> {textInfo}
                        </Col>
                        <Col md={3} align="right">
                            <OverlayTrigger trigger="focus" placement="left" overlay={ MainAyuda }>
                                <button className="btn btn-relleno-success" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i></button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </div>
                <Row className="custom-mt-20">
                    <Col md={6}>
                        <div className={codigo.status}>
                            <input type="text" value={codigo.text} onChange={this.cambiaValor("codigo")} className="form-control" placeholder="* Código de la Materia"/>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className={nombre.status}>
                            <input type="text" value={nombre.text} onChange={this.cambiaValor("nombre")} className="form-control" placeholder="* Nombre de la Materia"/>
                        </div>
                    </Col>

                    <Col md={6} className="custom-mt-10">
                        <Select
                            styles={{menu: customStyles}}
                            isSearchable ={true}
                            value={valorPrelacion1}
                            onChange={this.valorPrelacion1}
                            options={prelaciones}
                        />
                    </Col>
                    <Col md={6} className="custom-mt-10">
                        <Select
                            styles={{menu: customStyles}}
                            isSearchable ={true}
                            value={valorPrelacion2}
                            onChange={this.valorPrelacion2}
                            options={prelaciones}
                        />
                    </Col>
                    
                    <Col md={12} className="custom-mt-10">
                        <div className={horas.status}>
                            <input type="text" value={horas.text} maxLength={190} onChange={this.cambiaValor("horas")} className="form-control" placeholder="* Observaciones"/>
                        </div>
                    </Col>
                    <Col md={4} className="custom-mt-10">
                        <div className={uc.status}>
                            <input type="text" value={uc.text} onChange={this.cambiaValor("uc")} className="form-control" placeholder="* U.C. / Horas"/>
                        </div>
                    </Col>
                    <Col md={4} className="custom-mt-10">
                        <Select
                            isSearchable ={true}
                            value={valorModalidad}
                            onChange={this.valorModalidad}
                            options={modalidades}
                        />
                    </Col>
                    <Col md={4} className="custom-mt-10">
                        <Select
                            isSearchable ={true}
                            value={valorTipoMat}
                            onChange={this.valorTipoMat}
                            options={TiposMat}
                        />
                    </Col>
                </Row>
                <Row>
                    {/* <Col md={6} className="custom-mt-20">
                        <div className="form-check" align="center">
                            <input type="checkbox" checked={chkIntensivo} onClick = {this.cambiaChkIntensivo()} className="form-check-input" id="intensivo" /> <label className="form-check-label" htmlFor="intensivo"  style={{cursor: "pointer"}} title="Esta opción permite que el estudiante pueda agregar la asignatura en el PERIODO INTENSIVO">Disponible en Intensivo</label>
                        </div>
                    </Col> */}
                    <Col md ={7} className="custom-mt-20"><div className="text-danger">{ cantErrores }</div></Col>
                    <Col md={5} className="custom-mt-20" align="right">
                        {this.botones()}
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    render() { 
        return (
            <Grid fluid>
                <Row>
                    <Col md={4}>{this.materias()}</Col>
                    <Col md={8}>{this.registro()}</Col>
                </Row>
                {this.delMateria()}
            </Grid>
        );
    }
}
 
export default Materias;


// WEBPACK FOOTER //
// ./src/views/Registros/Materias.jsx